import './src/styles/global.css';

// Scroll on route change is handled entirely by shouldUpdateScroll below.
// (The previous onRouteUpdate window.scrollTo(0,0) was a redundant second scroll
// on every PUSH — combined with global smooth-scroll it fought the router's own
// scroll and made navigation feel janky.)

// Single export for scroll behavior
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Return false to prevent scroll-to-top on same-page anchor links
  if (location.hash) {
    return false;
  }
  
  // Scroll to top for PUSH actions (new routes)
  if (location.action === 'PUSH') {
    return [0, 0];
  }

  // For POP actions (back/forward), restore the previous scroll position
  return getSavedScrollPosition(location) || true;
};

// Defer third-party scripts until after load to reduce main-thread work (TBT)
function runAfterLoad(fn) {
  if (typeof window === "undefined") return;
  if (document.readyState === "complete") {
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 1);
    }
  } else {
    window.addEventListener("load", () => {
      if (typeof requestIdleCallback !== "undefined") {
        requestIdleCallback(fn, { timeout: 2000 });
      } else {
        setTimeout(fn, 1);
      }
    });
  }
}

export const onInitialClientRender = () => {
  if (typeof window !== "undefined") {
    runAfterLoad(() => {
      // Vector tracking script
      try {
        if (window.vector) return;
        var t = {};
        t.q = t.q || [];
        ["load", "identify", "on"].forEach(function (method) {
          t[method] = function () {
            t.q.push([method, Array.prototype.slice.call(arguments)]);
          };
        });
        window.vector = t;
        var i = document.createElement("script");
        i.type = "text/javascript";
        i.async = true;
        i.src = "https://cdn.vector.co/pixel.js";
        document.getElementsByTagName("script")[0].parentNode.insertBefore(i, document.getElementsByTagName("script")[0]);
        t.loaded = true;
        window.vector.load("cf013994-97b4-4356-9970-16d17edef138");
      } catch (e) {
        console.error("Error loading Vector:", e);
      }

      // OptinMonster Popup - Savings Report Campaign
      (function (d, u, ac) {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.src = "https://a.omappapi.com/app/js/api.min.js";
        s.async = true;
        s.dataset.user = u;
        s.dataset.campaign = ac;
        d.getElementsByTagName("head")[0].appendChild(s);
      })(document, 220803, "ex7hhyxxflbtovoztyrz");

      // OptinMonster Sidebar CTA New Campaign
      (function (d, u, ac) {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.src = "https://a.omappapi.com/app/js/api.min.js";
        s.async = true;
        s.dataset.user = u;
        s.dataset.campaign = ac;
        d.getElementsByTagName("head")[0].appendChild(s);
      })(document, 220803, "lpbpg3el03hoixdmlj4e");
    });
  }
};
